import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const data = [
  { name: "Island", value: 162 },
  { name: "Mainland", value: 90 },
  { name: "Others", value: 10 },
];

const COLORS = ["#26A65D", "#1970E6", "#E41B1B"];

const OrderPerDelivery = () => {
  return (
    <div style={{ width: "100%", height: 250 }}>
      <ResponsiveContainer>
        <ComposedChart
          layout="vertical"
          data={data}
          margin={{ top: 5, right: 20, bottom: 20, left: 20 }}
          outerRadius={80}
          innerRadius={50}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis
            type="number"
            orientation="top"
            ticks={[0, 25, 50, 75, 100, 125, 150, 175, 200]}
          />
          <YAxis dataKey="name" type="category" scale="band" />
          <Tooltip />

          <Bar dataKey="value" barSize={40}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OrderPerDelivery;
